import { Flex } from '@chakra-ui/react'
import React from 'react'
import { useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'

const ManualViewer = () => {
    const { itemData } = useSelectedItemAlertContext()
    return (
        <Flex w="full" h="75vh">
            {/* {itemData && <iframe width="100%" src={itemData.type} title="manual_preview" />} */}
            {itemData &&
                <object data={itemData.type} type="application/pdf" width="100%" >
                    <iframe src={`https://docs.google.com/viewer?url=${itemData.type}&embedded=true`}
                        title="manual_preview" />
                </object>}
        </Flex>
    )
}

export default ManualViewer
